import { timezoneDateTime } from '@/helpers/datetime'
import { useEffect, useState } from 'react'

export function TextCountdown({ targetDate, className }) {
  const countDownDate = new Date(targetDate.toDate()).getTime()

  const [countDown, setCountDown] = useState(
    new Date(countDownDate - new Date().getTime()),
  )
  const [daysCountdown, setDaysCountdown] = useState('')

  useEffect(() => {
    const diff = timezoneDateTime({
      datetime: new Date(targetDate.toDate()),
      format: 'diff',
    })

    if (diff > 0) {
      setDaysCountdown(
        timezoneDateTime({
          datetime: new Date(targetDate.toDate()),
          format: 'relative',
          hideRelativeSuffix: true,
        }),
      )
    }
  }, [targetDate])

  useEffect(() => {
    const interval = setInterval(() => {
      setCountDown(new Date(countDownDate - new Date().getTime()))
    }, 1000)

    return () => clearInterval(interval)
  }, [countDownDate])

  return (
    <p className={className}>
      {daysCountdown
        ? daysCountdown
        : timezoneDateTime({
            datetime: countDown,
            format: 'HH:mm:ss',
          })}
    </p>
  )
}
